// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// export const environment = {
//   production: false
// };

export const environment = {
  production: false,
  // ipAdressePT: 'http://192.168.178.91:88',
  // ipAdresseOO: "http://192.168.178.91:80",
  firebase: {
    apiKey: "AIzaSyAxtnHe22GOITamfs3ZLhppBPeSv59R4JI",
    authDomain: "bps-angular.firebaseapp.com",
    databaseURL: "https://bps-angular.firebaseio.com",
    projectId: "bps-angular",
    storageBucket: "bps-angular.appspot.com",
    messagingSenderId: "521701754121",
    appId: "1:521701754121:web:f36dac650a086cc2"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
